class LoaderService {
    constructor() {
      this.loaderElement = null; // Reference to the loader element
    }
  
    setLoaderElement(loaderElement) {
      this.loaderElement = loaderElement;
    }
  
    showLoader() {
      if (this.loaderElement) {
        this.loaderElement.style.display = 'block'; // Show the loader element
      }
    }
  
    // Method to hide the loader
    hideLoader() {
      if (this.loaderElement) {
        this.loaderElement.style.display = 'none'; // Hide the loader element
      }
    }
  }
  
  const loaderService = new LoaderService();
  
  export default loaderService;
  